<template>
  <el-dialog title="角色权限分配" :visible.sync="_dialogVisible" :close-on-click-modal="false">
    <el-tree :data="dataList" show-checkbox node-key="id" :default-checked-keys="checkedResourcesId" :props="defaultProps" @check="handleCheck" v-loading="dataLoading" default-expand-all></el-tree>

    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
      required: true,
    },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  watch: {
    _dialogVisible(val) {
      if (val) {
        this.loadRoleResourceList();
      }
    },
  },
  data() {
    return {
      dataLoading: false,
      btnLoading: false,
      dataList: [],
      checkedResourcesId: [],
      submitResourcesId: [],
      defaultProps: {
        children: "children",
        label: "resourcesName",
      },
    };
  },
  methods: {
    loadRoleResourceList() {
      this.dataLoading = true;
      this.$http({
        url: global.apiUrl + `/role/roleResources/${this.id}`,
        method: "GET",
        params: { supplyId: this.supplyId },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dataList = res.body.data.data;
              const { checkedResourcesId, submitResourcesId } = this._getCheckedResourcesId();
              this.checkedResourcesId = checkedResourcesId;
              this.submitResourcesId = submitResourcesId;
            } else {
              this.dataList = [];
            }
          } else {
          }
          this.dataLoading = false;
        })
        .catch(err => {
          this.dataLoading = false;

          console.error(err);
        });
    },
    /**
     * 获取已选择的资源id
     */
    _getCheckedResourcesId() {
      const checkedResourcesId = []; // 显示id
      const submitResourcesId = []; // 提交id
      return (function func(data) {
        for (let i = 0, len = data.length; i < len; i++) {
          if (data[i].checked) {
            submitResourcesId.push(data[i].id);
          }

          if (data[i].children.length > 0) {
            func(data[i].children);
          } else {
            if (data[i].checked) {
              checkedResourcesId.push(data[i].id);
            }
          }
        }
        return {
          checkedResourcesId: checkedResourcesId,
          submitResourcesId: submitResourcesId,
        };
      })(this.dataList);
    },
    handleCheck(currentObj, treeStatusObj) {
      this.checkedResourcesId = [...treeStatusObj.checkedKeys];
      this.submitResourcesId = [...treeStatusObj.checkedKeys, ...treeStatusObj.halfCheckedKeys];
    },
    /**
     * 角色分配权限
     */
    handleSubmit() {
      this.btnLoading = true;
      const params = {
        roleId: this.id,
        resourcesId: this.submitResourcesId,
      };

      this.$http({
        url: this.form.id ? global.apiUrl + "/role/editRole" : global.apiUrl + "/role/addRole",
        method: this.form.id ? "PUT" : "POST",
        body: params,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this._dialogVisible = false;
          } else {
          }
          setTimeout(() => {
            this.btnLoading = false;
          }, 500);
        })
        .catch(err => {
          this.btnLoading = false;

          console.error(err);
        });
    },
  },
};
</script>
<style lang="less" scoped></style>
